'use client';

import LandingHero from '../components/landing/landing-hero';
import LandingTools from '../components/landing/landing-tools';
import LandingServices from '../components/landing/landing-services';
import LandingVideos from '../components/landing/landing-videos';
import LandingProcess from '../components/landing/landing-process';
import LandingStats from '../components/landing/landing-stats';
import LandingTestimonials from '../components/landing/landing-testimonials';
import LandingCta from '../components/landing/landing-cta';

export default function Home() {
	return (
		<main className="flex flex-col">
			<section className="relative min-h-screen flex items-center pb-16 md:pb-20 overflow-hidden">
				{/* Dark: warm Jupiter glow */}
				<div className="absolute inset-0 jupiter-gradient opacity-10 hidden dark:block" />
				{/* Light: cool brand-purple wash so the hero reads as a distinct panel */}
				<div className="absolute inset-0 bg-gradient-to-b from-purple-500/20 via-purple-500/[0.06] to-transparent dark:hidden" />
				<div className="pointer-events-none absolute -top-1/4 left-1/2 h-[650px] w-[650px] -translate-x-1/2 rounded-full bg-purple-500/25 blur-[130px] dark:bg-orange-500/20" />
				<div className="relative w-full pt-24 sm:pt-32 md:pt-40">
					<LandingHero />
				</div>
			</section>

			<section id="tools" className="relative z-20 scroll-mt-24 py-16 md:py-24">
				<LandingTools />
			</section>

			<section className="relative z-20 py-16 md:py-24">
				<LandingServices />
			</section>

			<section className="relative py-16 md:py-24">
				<LandingVideos />
			</section>

			<section className="relative bg-muted/40 py-16 md:py-24">
				<LandingProcess />
			</section>

			<section className="relative py-16 md:py-24">
				<LandingStats />
			</section>

			<section className="relative bg-muted/40 py-16 md:py-24">
				<LandingTestimonials />
			</section>

			<section className="relative py-16 md:py-24 pb-24 md:pb-32">
				<LandingCta />
			</section>
		</main>
	);
}
